import React, { useState } from "react";
import { Radio } from "antd"; // Import Ant Design Radio
import Button from "../../components/ui/Button";
import Typography from "../../components/typography/Typography";

function isUrlValid(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

const testData = [
  {
    section: "Mathematics",
    questions: [
      {
        question: "What is the capital of France?",
        options: ["Paris", "London", "Rome", "Berlin"],
        correctAnswer: "Paris",
      },
      {
        question:
          "https://5.imimg.com/data5/AU/NW/MY-6824707/alphonso-mangoe-larga-500x500.jpg",
        options: [
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRN0Wfpzw8BkVS0tkIF8mVR-MatKmkaFlREGA&s",
          "https://orchardfruit.com/cdn/shop/files/Mango-Whole-The-Orchard-Fruit-72136115.jpg?v=1722937809&width=1000",
          "https://5.imimg.com/data5/AU/NW/MY-6824707/alphonso-mangoe-larga-500x500.jpg",
          "https://orchardfruit.com/cdn/shop/files/Grapefruit-Pcs-The-Orchard-Fruit-72137513.jpg?v=1722937850&width=1125",
        ],
        correctAnswer:
          "https://5.imimg.com/data5/AU/NW/MY-6824707/alphonso-mangoe-larga-500x500.jpg",
      },
    ],
  },
  {
    section: "General Knowledge",
    questions: [
      {
        question: "What is 2 + 2?",
        options: ["3", "4", "5", "6"],
        correctAnswer: "4",
      },
      {
        question: "Who is the current President of the US?",
        options: ["Joe Biden", "Donald Trump", "Barack Obama", "George Bush"],
        correctAnswer: "Joe Biden",
      },
    ],
  },
];

function AptitudeTestQuestions() {
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);

  const currentSection = testData[currentSectionIndex];
  const currentQuestion = currentSection.questions[currentQuestionIndex];

  const handleAnswerChange = (e) => {
    const selectedAnswer = e.target.value;
    setAnswers((prev) => ({
      ...prev,
      [`${currentSectionIndex}-${currentQuestionIndex}`]: selectedAnswer,
    }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < currentSection.questions.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
    } else if (currentSectionIndex < testData.length - 1) {
      setCurrentSectionIndex((prev) => prev + 1);
      setCurrentQuestionIndex(0);
    } else {
      setShowResults(true);
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
    } else if (currentSectionIndex > 0) {
      setCurrentSectionIndex((prev) => prev - 1);
      setCurrentQuestionIndex(
        testData[currentSectionIndex - 1].questions.length - 1
      );
    }
  };

  const calculateScore = () => {
    let score = 0;
    testData.forEach((section, sectionIndex) => {
      section.questions.forEach((question, questionIndex) => {
        if (
          answers[`${sectionIndex}-${questionIndex}`] === question.correctAnswer
        ) {
          score += 1;
        }
      });
    });
    return score;
  };

  return (
    <section className="containerLayout py-20 flex flex-col gap-3">
      <Typography variant="h2-title">Pronttera Labs Aptitude Test</Typography>

      {showResults ? (
        <div>
          <h2>Results</h2>
          <p>
            Your score: {calculateScore()} /{" "}
            {testData.reduce(
              (total, section) => total + section.questions.length,
              0
            )}
          </p>
        </div>
      ) : (
        <div>
          <Typography variant="h3-title">{currentSection.section}</Typography>
          <Typography variant="p-text">
            Question {currentQuestionIndex + 1} of{" "}
            {currentSection.questions.length}
          </Typography>
          {isUrlValid(currentQuestion.question) ? (
            <img
              className="max-w-[200px] max-h-[200px] my-3"
              src={currentQuestion.question}
              alt="option img"
            />
          ) : (
            <Typography variant="h3-title" className="text-center my-3">
              {currentQuestion.question}
            </Typography>
          )}

          <Radio.Group
            onChange={handleAnswerChange}
            value={
              answers[`${currentSectionIndex}-${currentQuestionIndex}`] || null
            }
            className="grid grid-cols-1 md:grid-cols-2 gap-5 my-5"
          >
            {currentQuestion.options.map((option, index) => (
              <Radio
                key={index}
                value={option}
                className="flex items-center md:min-h-[100px] m-0 bg-gray-200 p-2 rounded-lg hover:bg-gray-300 ease-in-out duration-300"
              >
                {isUrlValid(option) ? (
                  <img
                    className="max-w-[200px] max-h-[200px]"
                    src={option}
                    alt="Option"
                  />
                ) : (
                  <Typography variant="p-text">{option}</Typography>
                )}
              </Radio>
            ))}
          </Radio.Group>
          <div className="my-10 w-full gap-5 flex justify-center">
            <Button
              onClick={handlePrevious}
              disabled={currentSectionIndex === 0 && currentQuestionIndex === 0}
              className={`${
                currentSectionIndex === 0 && currentQuestionIndex === 0
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              } w-24`}
            >
              Previous
            </Button>
            <Button onClick={handleNext} className={"w-24"}>
              {currentSectionIndex === testData.length - 1 &&
              currentQuestionIndex === currentSection.questions.length - 1
                ? "Submit"
                : "Next"}
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}

export default AptitudeTestQuestions;
